if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (!window.SPORTOVA_TARIFF_SURCHARGE && window.SportovaTariffCart?.loadMap) {
          try {
            await window.SportovaTariffCart.loadMap();
          } catch (error) {
            console.error('Sportova tariff map could not load before add to cart', error);
          }
        }

        const formData = new FormData(this.form);
        const surchargeItem = this.getSportovaTariffSurchargeItem(formData);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (surchargeItem) {
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(this.buildSportovaCartAddPayload(formData, surchargeItem));
        } else {
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      getSportovaTariffSurchargeItem(formData) {
        const tariff = this.form.querySelector('sportova-tariff-acknowledgement');
        const checkbox = tariff?.querySelector('input[type="checkbox"]');
        if (tariff && !checkbox?.checked) return null;

        const variantId = String(formData.get('id') || '');
        const surchargeConfig = window.SPORTOVA_TARIFF_SURCHARGE || {};
        const amountCents = String(
          formData.get('properties[_usa_tariff_surcharge_cents]') ||
            formData.get('properties[USA tariff surcharge cents]') ||
            ''
        );
        let surcharge = null;
        const amountVariantId = amountCents ? surchargeConfig.amountVariantMap?.[amountCents] : null;
        if (amountVariantId) {
          surcharge = { surchargeVariantId: amountVariantId, amountCents };
        } else {
          surcharge = surchargeConfig.productVariantMap?.[variantId];
        }
        if (!surcharge?.surchargeVariantId) return null;

        return {
          id: Number(surcharge.surchargeVariantId),
          quantity: Math.max(1, Number(formData.get('quantity') || 1)),
          properties: {
            _sportova_tariff_surcharge: 'true',
            _sportova_tariff_parent_variant_id: variantId,
            _sportova_tariff_amount_cents: String(surcharge.amountCents || ''),
          },
        };
      }

      buildSportovaCartAddPayload(formData, surchargeItem) {
        const properties = {};
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.*)\]$/);
          if (match && value !== '') properties[match[1]] = value;
        }

        const mainItem = {
          id: Number(formData.get('id')),
          quantity: Math.max(1, Number(formData.get('quantity') || 1)),
          properties,
        };

        if (surchargeItem?.properties?._sportova_tariff_amount_cents) {
          const amountCents = surchargeItem.properties._sportova_tariff_amount_cents;
          mainItem.properties['USA tariff surcharge acknowledged'] ||= 'Yes';
          mainItem.properties['Tariff'] ||= '7.5% USA Tariff Surcharge (Required)';
          mainItem.properties['USA tariff surcharge rate'] ||= '7.5%';
          mainItem.properties['USA tariff surcharge cents'] ||= amountCents;
          mainItem.properties._usa_tariff_surcharge_cents ||= amountCents;
        }

        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) mainItem.selling_plan = sellingPlan;

        return {
          items: [mainItem, surchargeItem],
          sections: String(formData.get('sections') || '').split(',').filter(Boolean),
          sections_url: formData.get('sections_url') || window.location.pathname,
        };
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
